import allIcon from '@/assets/images/ai/all.png'
import { flatten } from 'lodash-es'
import { domesticModels, foreignModels } from '@/views/main/config/index'

export function chartConfig(data, isPc = true, theme = 'dark', chartName = '模型分布') {
  const nameColor = theme === 'light' ? '#1D2129' : '#fff'
  return {
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: ({d}%)',
    },
    color: data.map(item => item.color),
    series: [
      {
        name: chartName,
        type: 'pie',
        radius: ['35%', '60%'],
        avoidLabelOverlap: true,
        itemStyle: {
          borderWidth: 1,
          borderColor: '#ffffff',
        },
        label: {
          show: true,
          position: 'outside',
          formatter: ({ name, percent }) => `{name|${name}}{percent|${percent.toFixed(1)}%}`, // 为名称添加富文本标签
          rich: {
            percent: {
              color: nameColor,
              fontWeight: 'bold',
              fontSize: isPc ? 14 : 10, // 调大百分比字号
              padding: [2, 4],
              borderRadius: 4,
            },
            name: {
              color: nameColor, // 直接使用白色文字
              fontSize: isPc ? 14 : 10, // 单独设置名称字号
              align: 'center',
              textBorderWidth: 0, // 明确去掉文字描边
            },
          },
        },
        labelLine: {
          show: true,
          length: 10,
          length2: 20,
          color: 'rgba(255, 255, 255, 0.5)',
        },
        data,
      },
    ],
  }
}

const colors = [
  '#4080FF',
  '#FB7D02',
  '#FDCF8A',
  '#4DD363',
  '#7BE189',
  '#A871E3',
  '#C296ED',
  '#21D2D1',
  '#8AE6E0',
  '#F979B7',
  '#FC9EC6',
  '#E75480',
  '#FFB6C1',
  '#FF6B6B',
  '#FF8E8E', // 红色系
  '#4ECDC4',
  '#88D8C0', // 青绿色系
  '#556270',
  '#7A8A99', // 灰蓝色系
  '#C06C84',
  '#D291BC', // 粉紫色系
  '#F8B195',
  '#FBCEB1', // 橙黄色系
  '#6A7FDB',
  '#8FA2E8', // 蓝色
  '#5A69F5',
]
// 字段累加
let ins = 1
const defaultConfig = (data, type = 'inner', isPc = true,) => {
  const color = colors.shift() || '#1D2129'
  return {
    label: data.label,
    // eslint-disable-next-line no-plusplus
    value: ins++,
    model: data.value,
    isPc,
    icon: data.icon,
    totalCount: 0,
    color,
    isShow: false,
    type,
  }
}
export const allConfig = {
  label: '全部',
  value: '',
  model: '',
  type: '',
  isPc: false,
  icon: allIcon,
  totalCount: 0,
  color: '#5A69F5',
  isShow: true,
}
export const domesticConfig = flatten(
  domesticModels.map(item => {
    return [defaultConfig(item, 'inner'), defaultConfig(item, 'inner', false)]
  }),
)

export const foreignConfig = flatten(
  foreignModels.map(item => {
    return [defaultConfig(item, 'outer'), defaultConfig(item, 'outer', false)]
  }),
)

export const getSingleByMode = mode => {
  if (mode === 'inner') {
    return [allConfig, ...domesticConfig]
  }
  return [
    allConfig,
    ...foreignConfig.map((x, i) => {
      return { ...x, value: i + 1 }
    }),
  ]
}
